<template>
    <div class="container" v-loading="tableing">
        <div class="header"> 
            <div class="wxIcon"></div> 
            <el-button class="btu1" type="text" @click="nextClick()" v-if="count>=10"> <i class="el-icon-d-arrow-left"></i> 返回订单列表 </el-button>
        </div>
        <div class="tapTi">
            <div>
                <p style="font-size: 12px;margin-top: 10px;">正在使用微信支付交易</p>
                <p style="font-weight: bold;">支付信息编号：{{$route.query.payNum||''}}</p>
            </div>
            <div><b>{{$route.query.price||''}}</b> 元 </div>
        </div>
        <div class="qrBox">
            <div class="qrBox2">
                <div class="payShuo">
                    <p>微信扫码付款（元）</p>
                    <p> <b>{{$route.query.price||''}}</b> </p>
                </div>
                <div class="qrCodeEle" ref='qrCodeUrl'></div>
                <div class="qrbeizhu">
                    <p>打开手机微信</p>
                    <p>扫一扫继续支付</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import QRCode from 'qrcodejs2'
import utils from '../../lib/util'
    export default {
        name:"slToWechatQR",
        data() {
            return {
                tableing:false,
                timer:null,
                wxPayStatus:'',//'05'=付款成功 01 03=付款中 04=失败 
                count:0,
            }
        },
        components:{},
        watch: {},
        computed:{},
        created(){},
        beforeDestroy() {
            this.timer && window.clearTimeout(this.timer)
        },
        computed:{},
        mounted(){
            this.creatQrCode()
        },
        methods:{
            creatQrCode() {
                var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                    text: this.$route.query.url, // 需要转换为二维码的内容
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                    logoSrc:'https://wap-sz.aitestgo.com/showOnly/wxPayIcon.png',
                    correctLevel: QRCode.CorrectLevel.H
                })
                let that = this
                // 5s一次支付状态查询
                that.count = that.$options.data().count
                that.timer && window.clearTimeout(that.timer)
                that.lookSlPayStatus()

            },
            lookSlPayStatus(){
                let that = this
                that.count++;
                that.$axios.post('/examSign/slPayStatus',{
                    tradeNo:that.$route.query.payNum,
                    uid:Number(that.$base64.decode(window.localStorage.getItem('uid-web'))),
                }, res => {
                    // console.log('支付状态',JSON.parse(JSON.stringify(res)))
                    let v = res.data;
                    if (v.code == 0) {
                        if(!v.data.status){
                            v.data['status'] = '04'
                            v.data['merchantorderid'] = that.$route.query.payNum
                            v.data['orderfee'] = this.$route.query.price * 100
                            v.data['payee'] = v.data.orderfee
                        }
                        /**
                         * status 
                         * 01-订单创建（视为用户订单尚未操作结束）
                         * 03-支付异常(超时)处理中
                         * 04-支付失败(失败)
                         * 05-支付成功(成功)
                        */
                        that.wxPayStatus = v.data.status
                        if(v.data.status=='01'||v.data.status=='03'){//支付中
                            that.timer = window.setTimeout(function () {
                                that.lookSlPayStatus()
                            },5000);
                        }else if(v.data.status=='05'){//支付成功
                            that.timer && window.clearTimeout(that.timer)
                            that.payFinish(v.data)
                        }else if(v.data.status=='04'){//支付失败
                            that.timer && window.clearTimeout(that.timer)
                            that.payFinish(v.data)
                        }
                    }else{
                        if(v.msg)
                            that.$message.error(v.msg);
                        else
                            that.$message.error('请求错误');
                    }
                })
            },
            payFinish(data){
                let pro = {
                    returncode:data.returncode,
                    merchantorderid:data.merchantorderid,
                    orderfee:parseInt(data.orderfee) / 100,
                    payee:parseInt(data.orderfee) / 100,
                    responsetime:data.status=='05'?data.paytime:utils.fmtDate(new Date(data.timestamp),'yyyy-MM-dd hh:mm:ss')
                }
                this.$router.push({
                    path:'/payOk',
                    query:pro
                })
            },
            nextClick(){
                this.$confirm('是否退出当前页面？','确认信息',{
                    distinguishCancelAndClose:true,
                    confirmButtonText:'退出',
                    cancelButtonText:'取消',
                })
                .then(()=>{
                    this.timer && window.clearTimeout(this.timer)
                    this.$router.push({
                        path: '/myExamList',
                        query: {tab:2}
                    })
                })
                .catch((action)=>{})
            }
        }
    }
</script>
<style scoped lang="less">
    .container{
        width: 100%;
        height: 100%;
        position: relative;
        .header{
            position: absolute;
            top: 0;
            left: 40px;
            right: 40px;
            height: 60px;
            border-bottom: 1px solid #b3b3b3;
            .wxIcon{
                float: left;
                height: 100%;
                width: 200px;
                background: url('https://td.cdn-go.cn/enterprise_payment/v0.1.2/logo.svg');
                background-size: auto 65%;
                background-repeat: no-repeat;
                background-position: center left;
            }
            .btu1{
                float: right;
                margin: 15px 10px 0 0;
            }
        }
        .tapTi{
            position: absolute;
            top: 75px;
            left: 40px;
            right: 40px;
            height: 60px;
            box-sizing: border-box;
            padding: 0 20px;
            div:nth-child(1){
                display: inline-block;
                width: 50%;
                height: 100%;
                float: left;
                text-align: left;
            }
            div:nth-child(2){
                display: inline-block;
                width: 50%;
                height: 100%;
                float: right;
                text-align: right;
                display: flex;
                justify-content: end;
                align-items: center;
                b{
                    font-size: 22px;
                    color: #f60;
                }
            }
        }
        .qrBox{
            position: absolute;
            top: 140px;
            left: 40px;
            right: 40px;
            bottom: 1%;
            display: flex;
            justify-content: center;
            align-items: center;
            border-top: 3px solid #b3b3b3;
            border-bottom: 3px solid #b3b3b3;
            // background-color: #fff;
            .qrBox2{
                width: 282px;
                box-sizing: border-box;
                padding: 6px;
                border-radius: 6px;
                border: 1px solid #d3d3d3;
                box-shadow: 1px 1px 1px #ccc;
                background-color: #fff;
                .payShuo{
                    margin-bottom: 10px;
                    p:nth-child(1){}
                    p:nth-child(2){
                        font-size: 22px;
                        color: #f60;
                    }
                }
                .qrCodeEle{
                    width: 256px;
                    height: 256px;
                    display: inline-block;
                }
                .qrbeizhu{
                    font-size: 13px;
                    width: 160px;
                    height: 38px;
                    margin-left: 55px;
                    background: url('https://t.alipayobjects.com/images/T1bdtfXfdiXXXXXXXX.png');
                    background-repeat: no-repeat;
                    background-size: auto;
                    background-position: 15px 5px;
                    p{
                        float: right;
                        width: 100px;
                        text-align: left;
                        font-size: 12px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/myExamList/slToWechatQR.vue